module.exports = __webpack_public_path__ + "static/media/phone-volume.82eba2d0.svg";